import { DOM_IDS } from '../utils/constants';
export default function filterLanguageSelectorOptions({
  subscriptionStatuses
}) {
  if (!subscriptionStatuses) {
    return;
  }
  const availableLanguages = new Set(['default']);
  subscriptionStatuses.forEach(({
    translations
  }) => {
    Object.keys(translations).forEach(key => availableLanguages.add(key));
  });
  const languageSelector = document.getElementById(DOM_IDS.languageSelect);
  if (!languageSelector) {
    return;
  }
  const languageOptions = [...languageSelector.options];
  for (let i = 0; i < languageOptions.length; i++) {
    const option = languageOptions[i];
    if (!availableLanguages.has(option.value)) {
      languageSelector.options.remove(i);
      languageOptions.splice(i, 1);
      i--;
    }
  }

  // Hide the language selector if only default and en are available
  const languages = Array.from(languageSelector.options).map(option => option.value);
  if (languages.length === 1 && languages.includes('default') || languages.length === 2 && languages.includes('default') && languages.includes('en')) {
    languageSelector.style.display = 'none';
  }
}